@if (baseRules && !baseRules?.hasOutstanding && isReviewPage) {
  <h2 class="axis-h4">New Hampshire</h2>
  <div class="axis-grid">
    @if (baseRules.BIPDCombinedMinSingleLimit_DropDown) {
      <div class="axis-col-sm-6 axis-col-lg-4">
        <div class="axis-form-group">
          <label class="axis-control-label">{{ controls[0].label }} </label>
          <div>{{ controls[0].data[0].name }}</div>
        </div>
      </div>
    }
  </div>
}
